import {
  __name
} from "./chunk-2IB33T4A.js";

// src/errors/role-not-found.error.ts
var _RoleNotFoundError = class _RoleNotFoundError extends Error {
  constructor(categoriaId) {
    super(`N\xE3o existe role para a categoria ${categoriaId}`);
  }
};
__name(_RoleNotFoundError, "RoleNotFoundError");
var RoleNotFoundError = _RoleNotFoundError;

export {
  RoleNotFoundError
};
//# sourceMappingURL=chunk-BUN3PDXH.js.map